// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__tKSRC","avatar":"style_avatar__aKXjD","avatarDark":"style_avatarDark__lX7De"};